import { PropsWithChildren } from 'react';
import { useEditor } from '@craftjs/core';
import { theme } from '@frontend/theme';
import { Button, Heading } from '@frontend/design-system';

// TODO: Add tracking ids
export const SettingsPanelHeader = ({ children }: PropsWithChildren) => {
  const { actions } = useEditor();

  return (
    <div
      css={{
        alignItems: 'center',
        background: theme.colors.primary50,
        color: theme.colors.white,
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 1, 1, 2),
      }}
    >
      <Heading level={2} color='white'>
        {children}
      </Heading>
      <Button iconName='check' size='large' onClick={actions.clearEvents} />
    </div>
  );
};
